<template>
  <div class="body-wrapper">
    <table-polls></table-polls>
  </div>
</template>

<script>
import TablePolls from '@/components/table/TablePolls.vue';
import { mapMutations, mapActions } from 'vuex';

export default {
  components: {
    TablePolls
  },
  created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();

    //loading data to table
    this.getPollsByCommunity({
      communityId: this.$store.getters.getActiveCommunity.id
    });
  },
  methods: {
    ...mapActions('table', ['getPollsByCommunity']),
    ...mapMutations(['cardOpened'])
  }
};
</script>
<style lang="scss">
</style>
